import styled from 'styled-components';
import media from '../../base/media';

export const Wrapper = styled.div`
	${media.desktopSmall`
		margin-top: 8rem;
	`}
`;

export const ContentWrapper = styled.div`
	${media.desktopSmall`
		max-width: 50rem;
	`}
`;

export const ApartmentBoxWrapper = styled.div`

`;

export const ButtonWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	margin: 6rem 0;

	> a {
		margin: 1rem 0;
	}

	${media.desktopSmall`
		margin: 10rem 0;
		flex-direction: row;
		justify-content: space-between;
	`}
`;
